<template>
  <div class="history">
    <div class="h_title">督办管理</div>
    <div class="h_body">
      <div class="hb_head">
        <div>发起人：
          <el-input
            v-model.trim="params.startUserName"
            class="hbh_input"
            clearable
            placeholder="请输入发起人"
          />流程名称：
          <el-input
            v-model.trim="params.appName"
            class="hbh_input"
            clearable
            placeholder="请输入流程名称"
          />督办次数：
          <el-input
            v-model="params.superviseTimes"
            class="hbh_input"
            clearable
            placeholder="请输入督办次数"
          />
        </div>
        <div>
          <el-button
            type="primary"
            @click="searchTable"
          >查询</el-button>
          <el-button
            type="success"
            @click="handleExport"
          >
            导出<i class="el-icon-download el-icon--right" />
          </el-button>

        </div>
      </div>
      <div class="hb_main">
        <div class="hbm_right">
          <sw-table
            :loading="loading"
            :key="tablekey"
            :table-name="'history-table'"
            :table-data="tableData"
            :table-title="tableTitle"
            :has-operation="false"
            :show-selection="false"
            :total-count="tableCount"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :empty-text="sheetObj.name?'没有相关数据':'请先选择流程'"
            pagination
            @change-page="changePage"
            @size-change="changeSize"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service, { baseURL } from '@/utils/service'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
  name: 'History',
  directives: {
    'loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          '.el-select-dropdown .el-select-dropdown__wrap'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight + 20
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  data () {
    return {
      loading: false,
      activeName: '1',
      tableData: [],
      tableTitle: [{ prop: 'serialNumber', label: '流水号' }, { prop: 'appName', label: '流程名称' }, { prop: 'startUserName', label: '发起人' }, { prop: 'taskName', label: '督办节点' }, { prop: 'superviseTimes', label: '督办次数' }, { prop: 'superviseDate', label: '督办时间' }],
      tablekey: 0,
      tableCount: 0,
      page: 1,
      limit: 10,
      exportObj: {
        loading: false,
        data: []
      },
      flowObj: {
        value: '',
        options: [],
        placeholder: '请选择流程'
      },
      sheetObj: {
        name: '',
        baseFields: [],
        sheetFields: []
      },
      params: {
        startUserName: '',
        appName: '',
        superviseTimes: ''
      }
    }
  },
  created () {
    this.getTableData()
  },
  mounted () {
  },
  methods: {
    handleExport () {
      let queryParams = ''
      const keys = Object.keys(this.params)
      for (const key of keys) {
        if (this.params[key]) {
          queryParams += `${encodeURIComponent(key)}=${encodeURIComponent(this.params[key])}&`
        }
      }
      queryParams = queryParams.substring(0, queryParams.length - 1)
      window.open(baseURL + `/v1/supervision/exportExcel?${queryParams}&token=${localStorage.getItem('Admin-Token')}`, '_blank')
    },
    exportExcel (tableData) {
      var wopts = {
        bookType: 'xlsx',
        bookSST: true,
        type: 'binary'
      }
      var workBook = {
        SheetNames: ['Sheet1'],
        Sheets: {},
        Props: {}
      }
      // 1、XLSX.utils.json_to_sheet(data) 接收一个对象数组并返回一个基于对象关键字自动生成的“标题”的工作表，默认的列顺序由使用Object.keys的字段的第一次出现确定
      // 2、将数据放入对象workBook的Sheets中等待输出
      workBook.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(tableData)

      // 3、XLSX.write() 开始编写Excel表格
      // 4、changeData() 将数据处理成需要输出的格式
      FileSaver.saveAs(new Blob([this.changeData(XLSX.write(workBook, wopts))], { type: 'application/octet-stream' }), `督办列表.xlsx`)
    },
    changeData (s) {
      // 如果存在ArrayBuffer对象(es6) 最好采用该对象
      if (typeof ArrayBuffer !== 'undefined') {
        // 1、创建一个字节长度为s.length的内存区域
        const buf = new ArrayBuffer(s.length)

        // 2、创建一个指向buf的Unit8视图，开始于字节0，直到缓冲区的末尾
        const view = new Uint8Array(buf)

        // 3、返回指定位置的字符的Unicode编码
        for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
        return buf
      } else {
        const buf = new Array(s.length)
        for (let i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
        return buf
      }
    },
    searchTable () {
      this.page = 1
      this.getTableData()
    },
    changePage (page) {
      this.page = page
      this.getTableData()
    },
    changeSize (size) {
      this.limit = size
      this.getTableData()
    },
    getTableData () {
      this.loading = true
      const params = this.getParams()
      service
        .get('/v1/supervision/querySupvervisionList', { params })
        .then(res => {
          this.loading = false
          if (!res.data || !res.data.length) {
            this.tableData = []
            return
          }
          const data = res.data
          if (this.page === 1) {
            this.tablekey++
          }

          this.tableCount = res.count
          this.tableData = data
        })
    },
    getParams () {
      const params = {}
      params.startUserName = this.params.startUserName
      params.appName = this.params.appName
      params.superviseTimes = this.params.superviseTimes
      params.page = this.page
      params.limit = this.limit
      return params
    }

  }
}
</script>

<style lang="scss" scoped>
.hbh_input {
  width: 200px;
  margin-right: 15px;
}
.history {
  padding: 10px 20px;
  color: #445969;
  background-color: rgb(240, 245, 250);
  .h_date,
  .h_input {
    width: 140px;
  }
}
.h_title {
  padding-left: 4px;
  border-left: 3px solid #3394e1;
  font-size: 12px;
}
.h_body {
  margin-top: 10px;
  padding: 10px 15px;
  box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);
  background: #fff;
  height: 80vh;
}
.hb_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hb_main {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #ccc;
  display: flex;
}
.h_select {
  width: 300px;
}

.hbm_left {
  width: 320px;
  padding-right: 15px;
}
.hbm_right {
  flex: 1;
  overflow-x: auto;
}
.hml_item_wrapper {
  max-height: 50vh;
  overflow-y: auto;
  width: 305px;
}
.hbml_item {
  margin-bottom: 10px;
}

.hbmr_table {
}
.separator {
  font-size: 12px;
  width: 20px;
  text-align: center;
}
.needMore {
  padding: 0 20px;
  font-size: 13px;
  color: #ccc;
  cursor: pointer;
}
</style>
